exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".textInputControl{display:none}.textInputControl input{width:100%;padding:10px;min-height:20px;font-size:20px}@media only screen and (max-width: 1000px){.textInputControl{display:block}}\n", ""]);

